import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../../LicenceProfileHeader";
import LicenceProfileSubTabs from "../../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";
import LicenceHeader from "./LicenceHeader";
import LicenceDetails from "./LicenceDetails";
import { DocumentsGrid } from "../DocumentsGrid";
import BackToAuthorisationVersions from "./BackToAuthorisationVersions";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
  profileNo: string;
  licenceProfile: ILicenceProfile;
}

const HistoricLicence = ({
  licence,
  profileNo,
  licenceProfile,
}: LicenceDetailsProps) => {
  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToAuthorisationVersions profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceHeader licence={licence} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceDetails licence={licence} licenceProfile={licenceProfile} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <DocumentsGrid
            licenceId={licence.licenceid}
            createdByFilter={licence.documentCreatedByFilterValues}
            classificationFilter={licence.documentClassificationFilterValues}
            subclassificationFilter={
              licence.documentSubclassificationFilterValues
            }
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} licence={licence} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default HistoricLicence;
